import { Component, EventEmitter, Output } from '@angular/core';

import { ApiService } from '../../api/common/api.service';
import { DeviceManagerService } from '../../core/services/device-manager.service';
import { ImageManagerService } from '../../api/images/image-manager.service';
import { MessageService } from 'primeng/api';
import { StockImage } from '../../api/images/stock-image-model';
import { finalize } from 'rxjs';
import { WaitingIndicatorComponent } from '../waiting-indicator/waiting-indicator.component';

@Component({
	selector: 'mycampapp-select-stock-image',
	templateUrl: './select-stock-image.component.html',
	styleUrls: ['./select-stock-image.component.less'],
	animations: WaitingIndicatorComponent.animations,
})
export class SelectStockImageComponent
{
	@Output() imageSelected = new EventEmitter<StockImage>();

	busy = false;
	selectedImage?: StockImage;
	stockImages?: StockImage[];
	visible = true;

	constructor(public deviceManager: DeviceManagerService,
	            private imageManagerService: ImageManagerService,
	            private messageService: MessageService) { }

	ngOnInit(): void
	{
		this.loadStockImages();
	}

	onHide()
	{
		this.imageSelected.emit(undefined);
	}

	private loadStockImages()
	{
		this.busy = true;
		this.imageManagerService.getStockImages().pipe(finalize(() => this.busy = false)).subscribe({
			next: (stockImages: StockImage[]) => {
				this.stockImages = stockImages;
			},
			error: error => this.messageService.add({ severity: 'error', summary: 'Error', detail: ApiService.getMessage(error) })
		})
	}

	onOk()
	{
		this.imageSelected.emit(this.selectedImage);
	}
}
